import location from '@/api/product/location'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  locations: []
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_CATEGORY(state, data){
    state.categories = data
  },
  SET_LOCATION(state, data){
    state.locations = data
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        branch_id: context.state.branch_id,
        filter: {
          search: context.state.search
        }
      },
      attrubutes
    )
    return location.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  store(context, data) {
    return location.store(data)
  },
  destroy(context, id) {
    return location.destroy(id)
  },
  assignMultipleWarehouse(context, data) {
    return location.assignMultipleWarehouse(data)
  },
  async getLocation(context){
    let response = await location.getLocation()
    context.commit('SET_LOCATION', response.data)
  },
  getProduct(context){
    return location.getProduct()
  }
}